// extracted by mini-css-extract-plugin
export default {"sidebarEndcap":"styles_sidebarEndcap__-hUGa"};